import { render, staticRenderFns } from "./idcardExample.vue?vue&type=template&id=d17538b8&scoped=true"
import script from "./idcardExample.vue?vue&type=script&lang=js"
export * from "./idcardExample.vue?vue&type=script&lang=js"
import style0 from "./idcardExample.vue?vue&type=style&index=0&id=d17538b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17538b8",
  null
  
)

export default component.exports